export function getCustomMethod(state) {
	return state.customMethod
}

export function getInitialRoute() {
	return 'dashboard'
}
